import React from "react";
import { Field, ErrorMessage } from "formik";
import { productCategories } from "./data/productCategories";
import { FormikReactSelect } from "../../common/FormikReactSelect";
import { FormikCreateableMultiSelect } from "../../common/FormikCreateableMultiSelect";
import { Styles } from "react-select";

interface OverviewPageProps {
  selectCustomStyles?: Partial<Styles>;
};

export const OverviewPage = ({ selectCustomStyles }: OverviewPageProps) => (
<>
  <Field type="text" name="name" placeholder='Product Name' />
  <ErrorMessage name="name" component="div" />
  <Field name="category" as={FormikReactSelect} options={productCategories} customStyles={selectCustomStyles} placeholder="Categories" />
  <ErrorMessage name="category" component="div" />
  <Field name="certifications" as={FormikReactSelect} options={productCategories} customStyles={selectCustomStyles} isMulti placeholder="Certifications" />
  <ErrorMessage name="certifications" component="div" />
  <Field name="usp" as={FormikCreateableMultiSelect} customStyles={selectCustomStyles} placeholder="Unique selling propositions (USPs)" />
  <ErrorMessage name="usp" component="div" />
  <Field type="text" name="description" placeholder='Description' />
  <ErrorMessage name="description" component="div" />
</>
);
